export default {
    data() {
        return {
            urlSegments: null,
            url: null,
            paginationString: null,
            queryString: null,
        }
    },

    created() {
        let queryString = '';

        Array.from(new URLSearchParams(window.location.search))
            .forEach((key) => {
                // Care to explain what 'p' is, Pietersma?
                if (key[0] === 'p') {
                    return;
                }

                (queryString.length === 0)
                    ? queryString += `${key[0]}=${key[1]}`
                    : queryString += `&${key[0]}=${key[1]}`
            })
        ;

        if (queryString.length !== 0) {
            this.queryString = queryString;
        }
    },

    methods: {

        buildSelectedFilters(dataset = null) {

            if (! dataset) {
                dataset = document.querySelectorAll('[data-filter-reference]');
            }

            const referenceElements = dataset;
            const selectedValues = [];
            let referenceValue = null;

            referenceElements.forEach(referenceElement => {

                const selectedValue = referenceElement.dataset.selectedValue;
                referenceValue = referenceElement.dataset.filterReference;

                if (selectedValue !== '' && typeof selectedValue !== 'undefined') {

                    if (typeof selectedValues[referenceValue] === 'undefined' || ! Array.isArray(selectedValues[referenceValue])) {
                        selectedValues[referenceValue] = [];
                    }

                    if (selectedValues[referenceValue].indexOf(selectedValue) === -1) {
                        selectedValues[referenceValue].push(selectedValue);
                    }
                }
            });

            this.selectedFilters = selectedValues;

            //process any filters that must be cleared
            for (let category in this.clearFilters) {

                if (this.selectedFilters.hasOwnProperty(category)) {

                    //remove a singular item from a category
                    this.selectedFilters[category] = this.selectedFilters[category].filter(item => ! this.clearFilters[category].includes(item));

                    //remove a string ("drenthe") from another string ("groningen,drenthe"), for example with multiple provinces
                    this.selectedFilters[category] = this.selectedFilters[category].map(item => item.replace(this.clearFilters[category], ""));

                    if (this.clearFilters[category].length === 0 || this.selectedFilters[category].length === 0) {
                        delete this.selectedFilters[category];
                    }
                }
            }
        },

        buildUrl() {

            this.buildSegments();

            this.Bus.emit('filter-segments-changed', this.urlSegments);
            this.Bus.emit('filter-url-changed', this.url);
        },

        buildSegments() {
            let urlSegments = [];

            // This if statement is used for components that implement the HandlesFilters separately from the main one
            if (this.prefixUrl && this.defaultPrefix) {
                const currentPrimary = this.prefixUrl.split('/').pop();
                let hasPrimary = this.isHiddenSegment(currentPrimary);

                // Find candidates for the primary
                const candidates = [{
                    name: this.defaultPrefix,
                    shouldReplaceDefault: false,
                    isPrimary: currentPrimary.startsWith(this.defaultPrefix)
                }];

                for (const category in this.selectedFilters) {
                    candidates.push(
                        ...this.selectedFilters[category]
                            .filter(value => this.isPrimaryFilter(category, value))
                            .map(value => ({
                                name: value,
                                shouldReplaceDefault: this.shouldReplaceDefault(category, value),
                                isPrimary: currentPrimary.startsWith(value)
                            }))
                    );
                }

                // console.log('current candidates:', candidates);
                let activePrimary = candidates.find(candidate => candidate.isPrimary);

                if (! activePrimary) {
                    activePrimary = {
                        name: this.defaultPrefix,
                        shouldReplaceDefault: false,
                        isPrimary: false,
                    }
                }

                const desiredReplacement =
                    ! hasPrimary
                        ? candidates.find(candidate => candidate.shouldReplaceDefault && (activePrimary === undefined || activePrimary.name === this.defaultPrefix))
                        : activePrimary;

                // console.log(activePrimary?.name, this.defaultPrefix);
                // console.log(activePrimary, desiredReplacement);

                if (desiredReplacement) {
                    let list = this.prefixUrl.split('/');
                    list.pop();
                    list.push(desiredReplacement.name);
                    this.prefixUrl = list.join('/');
                    hasPrimary = true;
                    // console.info('replaced', currentPrimary, 'with', desiredReplacement.name);
                }

                for (const categoryValue in this.selectedFilters) {
                    let selectedValues = this.selectedFilters[categoryValue];

                    selectedValues = selectedValues.filter(value => {
                        // If a primary is already set, just return true.
                        if (value === desiredReplacement?.name || value === activePrimary?.name) {
                            hasPrimary = true;
                            return false;
                        }

                        return true;
                    });

                    if (selectedValues.length > 0) {
                        const segment = `${categoryValue}:${selectedValues.join(',')}`;

                        urlSegments.push(segment);
                    }
                }

                if (! hasPrimary) {
                    // we need to replace the primary with the default as that's missing now.
                    let list = this.prefixUrl.split('/');
                    list.pop();
                    list.push(this.defaultPrefix);
                    this.prefixUrl = list.join('/');
                    // console.info('replaced', currentPrimary, 'with', this.defaultPrefix);
                }
            } else {
                for (const categoryValue in this.selectedFilters) {
                    const selectedValues = this.selectedFilters[categoryValue];
                    if (selectedValues.length > 0) {
                        const segment = `${categoryValue}:${selectedValues.join(',')}`;
                        urlSegments.push(segment);
                    }
                }
            }

            urlSegments = urlSegments.join(';');

            let url = this.prefixUrl ?? '';

            if (urlSegments.length > 0) {
                url += '/' + urlSegments;
            }

            //right trim trailing slashes
            url = url.replace(/\/+$/, '');

            if (this.paginationString) {
                url += '?p=' + this.paginationString;
            }

            if (this.queryString) {
                if (this.paginationString) {
                    url += '&' + this.queryString;
                }
                else {
                    url += '?' + this.queryString;
                }
            }

            this.url = url;
            this.urlSegments = urlSegments;
        },

        buildAll() {
            this.buildSelectedFilters();
            this.buildUrl();
        },

        isPrimaryFilter(category, reference) {

            return this.primaryFilterSegments.some(segment =>
                segment.groupReference === category &&
                segment.reference.startsWith(reference)
            );
        },

        shouldReplaceDefault(category, reference) {
            return this.primaryFilterSegments.some(segment =>
                segment.groupReference === category &&
                segment.reference.startsWith(reference) &&
                segment.replaceDefault
            );
        },

        isHiddenSegment(segment) {
            return this.hiddenSegments?.includes(segment) ?? false;
        },
    },
}
